import React from 'react';

import { Grid, Paper } from '@mui/material';

import Navigation from './Navigation';
import PageHeader from './PageHeader';
import TableHeader from './TableHeader';
import TopicContactsTable from './TopicContactsTable';

export default function GroupShow() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={1}>
        <Navigation />
      </Grid>
      <Grid item xs={12} lg={11}>
        <PageHeader />
        <Paper>
          <TableHeader />
          <TopicContactsTable />
        </Paper>
      </Grid>
    </Grid>
  );
}
